// import { request } from 'utils'
import { useEffect, useState } from 'react'
import { MARK_STATUS } from 'meinian-package/src/component/enum'

export default (options) => {
  const { inspirationId, needMarkTimes = 3 } = options
  const [option, setOption] = useState([])

  const levelEnum = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九'
  }

  useEffect(() => {
    if (inspirationId) {
      const start = [{ label: '待提审', value: `${MARK_STATUS.UNSET}`, markStatus: MARK_STATUS.UNSET }, { label: '待审核', value: `${MARK_STATUS.PENDING}`, markStatus: MARK_STATUS.PENDING }]
      const middle = []
      for (let i = 1; i <= needMarkTimes - 1; i++) {
        middle.push({ label: `${levelEnum[i]}审通过`, value: `${MARK_STATUS.PENDING},${i}`, markTimes: i, markStatus: MARK_STATUS.PENDING },)
      }
      const end = [{ label: '已通过', value: `${MARK_STATUS.PASS}`, markStatus: MARK_STATUS.PASS },
        { label: '已拒回', value: `${MARK_STATUS.NOT_PASS}`, markStatus: MARK_STATUS.NOT_PASS }]

      const _option = [].concat(start).concat(middle).concat(end)

      setOption(_option)
    } else {
      setOption([
        { label: '待提审', value: `${MARK_STATUS.UNSET}`, markStatus: MARK_STATUS.UNSET },
        { label: '待审核', value: `${MARK_STATUS.PENDING}`, markStatus: MARK_STATUS.PENDING },
        { label: '已通过', value: `${MARK_STATUS.PASS}`, markStatus: MARK_STATUS.PASS },
        { label: '已拒回', value: `${MARK_STATUS.NOT_PASS}`, markStatus: MARK_STATUS.NOT_PASS },
      ])
    }
  }, [inspirationId])
  return option
}
